import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class XsltService {
  /**
   * Trasforma una stringa XML usando una stringa XSLT
   */
  transform(xmlString: string, xsltString: string): string {
    const parser = new DOMParser();

    // 1. Parsing delle stringhe XML e XSLT in DOMDocument
    const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
    // console.log(xmlString); 
    const xsltDoc = parser.parseFromString(xsltString, 'text/xml');

    // Controllo eventuali errori di parsing XML/XSLT
    this.checkParsingErrors(xmlDoc, 'XML');
    this.checkParsingErrors(xsltDoc, 'XSLT');

    // 2. Inizializzazione XSLTProcessor nativo del browser
    if (typeof XSLTProcessor === 'undefined') {
      throw new Error('XSLTProcessor non supportato da questo browser.');
    }

    const processor = new XSLTProcessor();
    processor.importStylesheet(xsltDoc);

    // 3. Esecuzione della trasformazione
    const resultDoc = processor.transformToDocument(xmlDoc);

    // 4. Serializzazione del risultato in stringa HTML
    const serializer = new XMLSerializer();
    return serializer.serializeToString(resultDoc);
  }

  private checkParsingErrors(doc: Document, type: string): void {
    const errorNode = doc.querySelector('parsererror');
    if (errorNode) {
      throw new Error(`Errore di sintassi nel documento ${type}: ${errorNode.textContent}`);
    }
  }
}